<template>
  <div>
    <Modal max-width="340" :show.sync="showAnonModal" :close="closeAnonModal" :persistent="true">
      <template #title>
        <span class="title">Confirmer la Suppression </span>
      </template>
      <template #text>
        <h2 class="bold">
          Voulez-vous vraiment supprimer ce contact lié?
        </h2>
      </template>
      <v-spacer />
      <template #actions>
        <v-col>
          <v-btn width="292" class="mr- mb-2" :loading="loading" color="primary" @click="removeContact">
            <span class="ml-2 d-none d-sm-inline-block">Oui</span>
          </v-btn>
          <v-btn v-if="!loading" width="292" class="mr-2" color="secondary" @click="closeAnonModal">
            <span class="ml-2 d-none d-sm-inline-block">Non</span>
          </v-btn>
        </v-col>
      </template>
    </Modal>
  </div>
</template>
<script>
import { EventBus } from '../../mixins';
import Modal from '@/components/Modal/Modal';

export default {
  components: { Modal },
  props: {
    contact: {
      type: String,
      default: ''
    },
    content: {
      type: Object,
      default: null
    },
    saveCustomer: {
      type: Function,
      required: true
    }
  },
  data () {
    return { showAnonModal: false, loading: false };
  },
  mounted () {
    EventBus.$on('removeContactConfirm', () => {
      this.showAnonModal = true;
    });
  },
  methods: {
    closeAnonModal () {
      this.showAnonModal = false;
    },
    async removeContact () {
      this.loading = true;
      const newCustomer = { ...this.content };
      newCustomer.contacts = newCustomer.contacts.filter(c => c.uuid !== this.contact);
      await this.saveCustomer(newCustomer);
      this.loading = false;
      this.closeAnonModal();
    }
  }
};
</script>
